import { createContext, use, type ReactNode } from 'react'

const ImageLoadingContext = createContext<{ pending: boolean; onRetry?: () => void }>({ pending: false })

/** The host prepares stored media; images display that host's loading and retry feedback. */
export function ImageLoadingProvider(props: { pending: boolean; onRetry?: () => void; children: ReactNode }) {
  return <ImageLoadingContext value={props}>{props.children}</ImageLoadingContext>
}

export function useImageLoading() { return use(ImageLoadingContext) }
